export default __webpack_public_path__ + "static/media/DashboardLightActive.9b00fe07.svg";